/**
 * Thank you to https://stackoverflow.com/a/33852627/13931027 for this
 * nice summation-based solution
 * - for the pts input, for each point, the first array entry is x, and the second is y
 * @param {Array<[number, number]>} pts
 * @returns {{ X: number, Y: number }}
 */
export function findCentroid(pts) {
  var nPts = pts.length;
  var offset = pts[0];
  var twicearea = 0;
  var x = 0;
  var y = 0;
  var p1, p2;
  var f;

  for (var i = 0, j = nPts - 1; i < nPts; j = i++) {
      p1 = pts[i];
      p2 = pts[j];
      f = (p1[0] - offset[0]) * (p2[1] - offset[1]) - (p2[0] - offset[0]) * (p1[1] - offset[1]);
      twicearea += f;
      x += (p1[0] + p2[0] - 2 * offset[0]) * f;
      y += (p1[1] + p2[1] - 2 * offset[1]) * f;
  }
  f = twicearea * 3;

  return {
    X: x / f + offset[0],
    Y: y / f + offset[1]
  };
}
